import TradingPackDetail from './TradingPackDetail';

export default TradingPackDetail;
